import React, { useState, useEffect } from 'react'

const PopUpReddit = () => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    // Comprobar si el popup ya se ha mostrado en esta sesión
    const hasBeenShown = localStorage.getItem('redditPopupShown')

    if (!hasBeenShown) {
      // Mostrar el pop-up después de 45 segundos
      const timer = setTimeout(() => {
        setIsVisible(true)
      }, 45000)

      return () => clearTimeout(timer)
    }
  }, [])

  const handleClose = () => {
    setIsVisible(false)
    // Guardar en localStorage para no mostrar de nuevo en esta sesión
    localStorage.setItem('redditPopupShown', 'true')
  }

  const handleBackdropClick = (e) => {
    // Cerrar el popup si se hace clic en el fondo (no en el contenido)
    if (e.target === e.currentTarget) {
      handleClose()
    }
  }

  // Si no es visible, no renderizar nada
  if (!isVisible) return null

  return (
    <div
      className='fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50'
      onClick={handleBackdropClick}
      aria-modal='true'
      role='dialog'
    >
      <div className='bg-card max-w-md w-full rounded-lg shadow-lg overflow-hidden relative'>
        {/* Botón de cerrar */}
        <button
          onClick={handleClose}
          className='absolute top-3 right-3 text-text-secondary hover:text-text-primary'
          aria-label='Cerrar'
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            className='h-6 w-6'
            fill='none'
            viewBox='0 0 24 24'
            stroke='currentColor'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M6 18L18 6M6 6l12 12'
            />
          </svg>
        </button>

        {/* Contenido del pop-up */}
        <div className='p-6'>
          <h2 className='text-xl font-bold text-center mb-4'>
            ¡Ayúdanos a crear el mejor conversor para profesionales!
          </h2>

          <div className='flex justify-center mb-4'>
            <img
              src='/resources/images/Building-blocks-cuate.svg'
              alt='Comunidad'
              className='w-40 h-40'
            />
          </div>

          <p className='text-text-secondary text-center mb-3'>
            Tu experiencia es valiosa. Únete a nuestra comunidad en Reddit y
            comparte ideas que harían tu trabajo más fácil y eficiente.
          </p>

          <p className='text-text-secondary text-center mb-3'>
            ¿Qué funcionalidad te gustaría ver? ¿Cómo podemos mejorar tu
            experiencia diaria?
          </p>

          <p className='text-text-secondary text-center mb-6 font-medium'>
            ¡Tu voz da forma al futuro de esta herramienta!
          </p>

          <div className='flex justify-center'>
            <a
              href='https://www.reddit.com/r/ConversorIAE_CNAE/'
              target='_blank'
              rel='noopener noreferrer'
              className='bg-primary text-background px-6 py-3 rounded font-medium hover:bg-opacity-90 transition-colors text-center'
              onClick={() => localStorage.setItem('redditPopupShown', 'true')}
            >
              Únete a la conversación
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PopUpReddit
